exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdf-icon{color:#dc3545}.xls-icon{color:#28a745}.ppt-icon{color:#fd7e14}.doc-icon{color:#007bff}.big-icon{font-size:55px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/document/document.scss
// module id = 4917
// module chunks = 0